/* eslint-disable prettier/prettier */
export const Colors = {
  root: "#4c4c4c",
  middle: "#FF8700",
  leaf: "#4EBE1B",
};

const Styles = {
  container: {
    background: "#fff",
    paddingBottom: "2rem",
    overflow: "auto",
  },
  blur: {
    opacity: 0.2,
  },
  subHeader: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "1rem",
  },
  filter: {
    display: "flex",
    width: "100%",
    gap: "1rem",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "0.5rem",
  },
  organogramDate: {
    display: "flex",
    width: "100%",
    gap: "1rem",
    justifyContent: "space-between",
    alignItems: "center",
  },
  // icon: {
  //   cursor: "pointer",
  // },
  disableIcon: {
    opacity: 0.5,
    backgroundColor: "white",
  },
  cardStyle: {
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 15,
    marginTop: 12,
    height: "calc(100% - 80px)",
    overflow: "auto",
    position: "relative",
  },
  root: {
    maxWidth: "300px",
    border: "2px solid #3b3b3b",
    borderColor: "#3b3b3b",
    // background: Colors.root,
    borderRadius: "16px",
    margin: "auto",
    position: "relative",
    minWidth: "200px",
  },
  rootheading: {
    color: "#222222",
    fontWeight: "600",
    fontSize: "18px",
  },
  level1summaryHeading: {
    color: "#222222",
    fontWeight: "600",
    fontSize: "18px",
  },
  level2summaryHeading: {
    color: "#222222",
    fontWeight: "600",
    fontSize: "18px",
  },
  summary: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px",
  },
  isOpenIcon: { transition: "all .4s", height: "24px", cursor: "pointer" },
  isClosedIcon: {
    transition: "all .4s",
    transform: "rotate(180deg)",
    height: "24px",
    cursor: "pointer",
  },
  editIcon: {
    cursor: "pointer",
    fontSize: 16,
    marginLeft: 2,
  },
  wrapper: {
    display: "grid",
    gridTemplateRows: "0fr",
    transition: "grid-template-rows 0.3s ease-out",
  },
  opendetails: {
    gridTemplateRows: "1fr",
  },
  inner: {
    overflow: "hidden",
  },
  detailContainer: {
    padding: "5px 12px",
    textAlign: "start",
    position: "relative",
  },
  addNewCard: {
    position: "absolute",
    zIndex: 100,
    right: -20,
    bottom: -18,
  },
  addNewStructureBtn: {
    borderRadius: "50%",
    width: 24,
    height: 24,
    backgroundColor: "white",
    fontSize: 14,
    fontWeight: 500,
    border: "1px solid #003E98",
    cursor: "pointer",
    padding: 0,
  },
  addNewleaderBtn: {},
  addLeaderBtn: {
    color: "black",
    backgroundColor: "inherit",
    border: "none",
    cursor: "pointer",
  },
  titlesContainer: {
    // borderTop: "1.5px solid #FF5083",
  },
  titleText: {
    color: "#222222",
    textTransform: "uppercase",
    opacity: 1,
    fontWeight: "600",
    fontSize: "14px",
    marginTop: "8px",
    display: "flex",
    gap: 10,
  },
  addLeader: {
    width: "100%",
    margin: "1rem 0 0.5rem 0",
    border: "1px solid #fff",
    cursor: "pointer",
    height: 32,
    borderRadius: 4,
    color: "#fff",
    fontWeight: 800,
  },
  subtitleText: {
    color: "#222222",
    textTransform: "capatalize",
    // fontWeight: "600",
    fontSize: "12px",
    marginBottom: "8px",
  },
  footerContent: {
    color: "#222222",
    textTransform: "capatalize",
    // fontWeight: "600",
    fontSize: "10px",
    borderTop: "1.5px solid",
    paddingTop: "8px",
    paddingBotttom: "8px",
  },
  createdby: {
    color: "#222222",
    textTransform: "uppercase",
    opacity: 1,
    fontWeight: "600",
    fontSize: "12px",
  },
  fixedNodeHeading: {
    color: "#222222",
    textTransform: "capatalize",
    fontSize: "14px",
  },
  creadtedTime: {
    textTransform: "capatalize",
    // fontWeight: "600",
    fontSize: "10px",
    // paddingTop: "8px",
    paddingBotttom: "8px",
  },
  fixedContainer: {
    padding: "5px 12px",
    textAlign: "start",
  },
  downloadPdf: {
    width: "max-content",
    minWidth: 141,
  },

  // Organogram Index styles

  main: {
    display: "flex",
    gap: "1rem",
    width: "60%",
  },
  leftMain: {
    flex: 1,
    minWidth: 260,
  },
  rightMain: {
    flex: 2,
    minWidth: 260,
  },
  btnContainer: {
    display: "flex",
    gap: "2rem",
    marginTop: "2rem",
  },
  inputWrapper: {
    display: "flex",
    marginTop: "0.5rem",
    minWidth: "243px",
    padding: "24px 24px 34px 24px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "10px",
    borderRadius: "8px",
    border: "1px solid #E0DEDE",
    backgroundColor: "rgba(224, 222, 222, 0.20)",
    height: "90%",
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #9DCBC6",
    borderRadius: "4px",
    padding: "8px",
    marginBottom: "8px",
    cursor: "pointer",
    background: "#F2FCFB",
    width: "100%",
  },
  icon: {
    cursor: "pointer",
    // marginRight: "16px",
    // fontSize: "10px",
  },
  download: {
    pointerEvent: "none",
    opacity: 0.5,
  },
  tableContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    marginTop: "2rem",
  },
  btn: {
    display: "flex",
    gap: "2rem",
    marginTop: "3rem",
  },
  pagination: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    margin: "30px 0",
    padding: "0 1rem",
  },
  tableHeadCells: {
    // padding: "8px",
    color: "#000000",
    fontWeight: 600,
    background: "#BAD9EC",
  },
};

export default Styles;
